export default {
  API_URL: 'https://enquest-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://enquestsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
